import Vue from 'vue';

import Login from '@/components/Login'; /*登陆页面*/
import Register from '@/components/Register'; /*注册页面*/
import Home from '@/components/Home'; /*首页页面*/
import Page404 from '@/components/404'; /*404页面*/

import personalCenter from '@/components/my/personalCenter'; /*个人中心页面*/

import oemInfo from '@/components/my/oemInfo'; /*oem页面*/
import companyInformation from '@/components/my/companyInformation'; /*我的公司资料页面*/

// import authManage from '@/components/agent/authManage' /*代理授权管理*/
// import agentBuy from '@/components/agent/agentBuy' /*代理购买记录*/
// import agentRecharge from '@/components/agent/agentRecharge' /*代理充值记录*/

import FastBI from '@/components/product/FastBI_products'; /*FastBI产品页面*/
import xzProduct from '@/components/xzReport/xzProduct';
import xzApiProduct from '@/components/xzReport/xzApiProduct';
import C9_products from '@/components/product/C9_products'; /*C9产品页面*/
import Suite from '@/components/product/Suite'; /*套件产品页面*/
import Module from '@/components/product/Module'; /*套件产品页面*/
import ModulePack from '@/components/product/ModulePack'; /*套件产品页面*/
import Offline from '@/components/product/offlineProduct'; /*离线授权页面*/
import Service from '@/components/product/Service'; /*人工服务页面*/
import Encryption from '@/components/product/Encryption'; /*人工服务页面*/

import materialList from '@/components/material/materialList'; // 素材管理
import fileList from '@/components/material/fileList';
import promotionList from '@/components/material/promotionList';
import myOrder from '@/components/order/myOrder'; /*我的订单页面*/
import SystemAgent from '@/components/system/agent'; /*代理商设置页面*/
import accountBalance from '@/components/financial/accountBalance'; /*账户余额页面*/
import rechargeDetails from '@/components/financial/rechargeDetails'; /*充值明细页面*/
import expenseDetails from '@/components/financial/expenseDetails'; /*消费明细页面*/
import settlement from '@/components/financial/settlement'; /*消结算价格页面*/
import systemAccountBalance from '@/components/system/accountBalance'; /*账户余额页面*/
import systemRechargeDetails from '@/components/system/rechargeDetails'; /*充值明细页面*/
import systemExpenseDetails from '@/components/system/expenseDetails'; /*消费明细页面*/
import partnerTrial from '@/components/system/partnerTrial';
import partnerInfo from '@/components/system/partnerInfo';
import AFCloud from '@/components/agileFlow/cloudProduct'    // af云产品
import AFLocal from '@/components/agileFlow/localProduct'    // af本地化产品

//后台
import Admin from '@/components/admin/layout.vue';
//运营
import appointment from '@/components/operation/appointment'; /*预约*/
import trailPhones from '@/components/operation/trail_phones'; /*申请试用-手机号*/
import cooperation from '@/components/operation/cooperation'; /*合作伙伴申请*/
import xzReportUserment from '@/components/operation/xzReportUserment'; /*预约*/

import Router from 'vue-router';
Vue.use(Router);

export const constantRoutes = [
  {
    path: '/login',
    name: '登录页',
    component: Login,
    hidden: true,
  },
  {
    path: '/register',
    name: '注册页',
    component: Register,
    hidden: true,
  },
  {
    path: '/',
    component: Home,
    name: '管理我的资料',
    redirect: '/companyInformation',
    meta: { title: '管理我的资料', icon: 'menu_icon01.png' },
    children: [
      {
        path: '/companyInformation',
        component: companyInformation,
        name: '我的公司资料',
        meta: { title: '我的公司资料' },
      },
      {
        path: '/personalCenter',
        component: personalCenter,
        name: '个人中心页面',
        meta: { title: '个人中心页面' },
      },
    ],
  },
  {
    path: '/admin',
    component: Admin,
    redirect: '/admin/operation/appointment',
    name: '运营统计',
    meta: { title: '运营统计', icon: 'menu_icon05.png', roles: 'none' },
    has: 'admin',
    children: [
      {
        path: '/admin/operation/appointment',
        component: appointment,
        name: '预约申请',
        meta: {
          title: '预约申请',
          roles: 'none',
        },
      },
      {
        path: '/admin/operation/trail_phones',
        component: trailPhones,
        name: '试用申请',
        meta: {
          title: '试用申请',
          roles: 'none',
        },
      },
      {
        path: '/admin/operation/cooperation',
        component: cooperation,
        name: '合作伙伴申请',
        meta: {
          title: '合作伙伴申请',
          roles: 'none',
        },
      },
      {
        path: '/admin/operation/xzUser',
        component: xzReportUserment,
        name: '小智用户',
        meta: {
          title: '小智用户',
          roles: 'none',
        },
      },
    ],
  },
];

export const FASTBIPATH = '/product/FastBI';

export const asyncRoutes = [
  {
    path: '/product',
    component: Home,
    redirect: FASTBIPATH,
    name: '管理FastBI产品',
    meta: { title: '管理FastBI产品', icon: 'menu_icon03.png', customRoles: ['is_superuser', 'permissions_fastbi_product', 'permissions_fastbi_package', 'permissions_fastbi_softwareDongle', 'permissions_fastbi_offline', 'permissions_fastbi_oem'] },
    children: [
      {
        path: FASTBIPATH,
        component: FastBI,
        name: '产品授权购买',
        meta: {
          title: '产品授权购买',
          customRoles: ['is_superuser', 'permissions_fastbi_product']
        },
      },
      // {
      //   path: '/product/module',
      //   component: Module,
      //   name: '增购产品模块',
      //   meta: {
      //     title: '增购产品模块',
      //     roles: [2, 0],

      //   },
      // },
      // {
      //   path: '/product/suite',
      //   component: Suite,
      //   name: '增购应用模块',
      //   meta: {
      //     title: '增购应用模块',
      //     roles: [2, 0],
      //   },
      // },
      {
        path: '/product/pack',
        component: ModulePack,
        name: '增购资源包',
        meta: {
          title: '增购资源包',
          customRoles: ['is_superuser', 'permissions_fastbi_package']
        },
      },
      {
        path: '/other/encryption',
        component: Encryption,
        name: '加密狗购买',
        meta: {
          title: '加密狗购买',
          customRoles: ['is_superuser', 'permissions_fastbi_softwareDongle']
        },
      },
      {
        path: '/product/offline',
        component: Offline,
        name: '离线授权许可',
        meta: {
          title: '离线授权许可',
          customRoles: ['is_superuser', 'permissions_fastbi_offline']
        },
      },
      {
        path: '/OEM',
        component: oemInfo,
        name: 'OEM管理',
        meta: { title: 'OEM管理', customRoles: ['is_superuser', 'permissions_fastbi_oem'] },
      },
    ],
  },
  {
    path: '/xzReport',
    component: Home,
    redirect: '/xzReport/xzProducts',
    name: '管理小智产品',
    meta: { title: '管理小智产品', icon: 'menu_icon03.png', customRoles: ['is_superuser', 'permissions_xz_sdk', 'permissions_xz_development'] },
    children: [
      {
        path: '/xzReport/xzProducts',
        component: xzProduct,
        name: '小智SDK购买',
        meta: {
          title: '小智SDK购买',
          customRoles: ['is_superuser', 'permissions_xz_sdk']
        },
      },
      {
        path: '/xzReport/xzApiProduct',
        component: xzApiProduct,
        name: '开发平台购买',
        meta: {
          title: '开发平台购买',
          customRoles: ['is_superuser', 'permissions_xz_development']
        },
      },
    ],
  },
  {
    path: '/agileFlow',
    component: Home,
    redirect: '/agileFlow/cloudProduct',
    name: '管理安捷云产品',
    meta: { title: '管理安捷云产品', icon: 'menu_icon03.png', customRoles: ['is_superuser', 'permissions_af_cloud', 'permissions_af_local'] },
    children: [
      {
        path: '/agileFlow/cloudProduct',
        component: AFCloud,
        name: '公有云产品管理',
        meta: {
          title: '公有云产品管理',
          customRoles: ['is_superuser', 'permissions_af_cloud']
        },
      },
      {
        path: '/xzReport/localProduct',
        component: AFLocal,
        name: '本地化产品管理',
        meta: {
          title: '本地化产品管理',
          customRoles: ['is_superuser', 'permissions_af_local']
        },
      },
    ],
  },
  // {
  //   path: '/other',
  //   component: Home,
  //   redirect: '/other/C9',
  //   name: '管理其他产品',
  //   meta: { title: '管理其他产品', icon: 'menu_icon03.png', roles: [2, 0] },
  //   children: [
  //     // {
  //     //   path:'/other/C9',
  //     //   component:C9_products,
  //     //   name:'C9产品购买',
  //     //   meta: {
  //     //     title: 'C9产品购买',
  //     //     roles: [2,0]
  //     //   }
  //     // },
  //     // {
  //     //   path:'/other/service',
  //     //   component:Service,
  //     //   name:'服务人天购买',
  //     //   meta: {
  //     //     title: '服务人天购买',
  //     //     roles: [2,0]
  //     //   }
  //     // },
  //     {
  //       path: '/other/encryption',
  //       component: Encryption,
  //       name: '加密狗购买',
  //       meta: {
  //         title: '加密狗购买',
  //         roles: [2, 0],
  //       },
  //     },
  //   ],
  // },
  {
    path: '/order',
    component: Home,
    redirect: '/order/myOrder',
    name: '订单管理',
    meta: { title: '订单管理', icon: 'menu_icon04.png', customRoles: ['is_superuser', 'roles_agent'] },
    children: [
      {
        path: '/order/myOrder',
        component: myOrder,
        name: '订单明细',
        meta: {
          title: '订单明细',
          customRoles: ['is_superuser', 'roles_agent']
        },
      },
    ],
  },
  {
    path: '/financial',
    component: Home,
    redirect: '/financial/accountBalance',
    name: '财务管理',
    meta: { title: '财务管理', icon: 'menu_icon05.png', customRoles: ['is_superuser', 'roles_agent'] },
    children: [
      {
        path: '/financial/accountBalance',
        component: accountBalance,
        name: '账户余额',
        meta: {
          title: '账户余额',
          customRoles: ['is_superuser', 'roles_agent']
        },
      },
      {
        path: '/financial/rechargeDetails',
        component: rechargeDetails,
        name: '充值明细',
        meta: {
          title: '充值明细',
          customRoles: ['is_superuser', 'roles_agent']
        },
      },
      {
        path: '/financial/expenseDetails',
        component: expenseDetails,
        name: '消费明细',
        meta: {
          title: '消费明细',
          customRoles: ['is_superuser', 'roles_agent']
        },
      },
      {
        path: '/financial/settlementPrice',
        component: settlement,
        name: '结算价格',
        meta: {
          title: '结算价格',
          customRoles: ['is_superuser', 'roles_agent']
        },
      },
    ],
  },
  {
    path: '/promotion',
    component: Home,
    redirect: '/promotion/materialList',
    name: '运营推广',
    meta: { title: '运营推广', icon: 'menu_icon05.png', customRoles: ['is_superuser', 'roles_agent', 'roles_operator'] },
    children: [
      {
        path: '/promotion/materialList',
        component: materialList,
        name: '小程序素材',
        meta: {
          title: '小程序素材',
          customRoles: ['is_superuser', 'roles_agent', 'roles_operator'],
        },
      },
      {
        path: '/promotion/fileList',
        component: fileList,
        name: '资料管理',
        meta: {
          title: '资料管理',
          customRoles: ['is_superuser', 'roles_agent', 'roles_operator'],

        },
      },
      {
        path: '/promotion/promotionList',
        component: promotionList,
        name: '推广列表',
        meta: {
          title: '推广列表',
          customRoles: ['is_superuser', 'roles_operator'],
        },
      },
    ],
  },
  {
    path: '/system',
    component: Home,
    redirect: '/system/agent',
    name: '系统管理',
    meta: { title: '系统管理', icon: 'menu_icon05.png', customRoles: ['is_superuser', 'roles_sales'] },
    children: [
      {
        path: '/system/agent',
        component: SystemAgent,
        name: '代理商设置',
        meta: {
          title: '代理商设置',
          // isSuper:true,   //只有管理员可以看到
          customRoles: ['is_superuser'],
        },
      },
      {
        path: '/system/accountBalance',
        component: systemAccountBalance,
        name: '伙伴账户余额表',
        meta: {
          title: '伙伴账户余额表',
          customRoles: ['is_superuser', 'roles_sales'],
        },
      },
      {
        path: '/system/rechargeDetails',
        component: systemRechargeDetails,
        name: '伙伴充值明细表',
        meta: {
          title: '伙伴充值明细表',
          customRoles: ['is_superuser', 'roles_sales'],
        },
      },
      {
        path: '/system/expenseDetails',
        component: systemExpenseDetails,
        name: '伙伴消费明细表',
        meta: {
          title: '伙伴消费明细表',
          customRoles: ['is_superuser', 'roles_sales'],
        },
      },
      // {
      //   path:'/system/partnerTrial',
      //   component:partnerTrial,
      //   name:'伙伴试用情况表',
      //   meta: {
      //     title: '伙伴试用情况表',
      //     isSuper:true,   //只有管理员可以看到

      //   }
      // },
      // {
      //   path:'/system/partnerInfo',
      //   component:partnerInfo,
      //   name:'伙伴情况一览表',
      //   meta: {
      //     title: '伙伴情况一览表',
      //     isSuper:true,   //只有管理员可以看到

      //   }
      // },
    ],
  },
  {
    path: '*',
    name: '404',
    component: Page404,
    hidden: true,
  },
];

const createRouter = () =>
  new Router({
    routes: constantRoutes,
  });
const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js